import { useAsync } from 'react-use';
import { loadCategoriesTree } from '../../data-layer/business/service';

export const useCategories = () => {
    const { loading, value } = useAsync(async () => {
        try {
            return await loadCategoriesTree();
        } catch (error) {
            return [];
        }
    }, []);

    return {
        isLoadingCategories: loading,
        categories: value,
    };
};
